// extracted by mini-css-extract-plugin
export default {"photo":"ConSidebar_photo__ffF8B"};